import { type EditorView } from 'prosemirror-view'

import { deleteCellContents } from 'common/Prose/Commands/table/mutation'
import { isTableSelection } from 'common/Prose/utils/table'
import { serializeTableForClipboard } from 'common/Prose/utils/table/serializeTableForClipboard'

export const copySelection =
  (cut = false) =>
  (view: EditorView) => {
    const clipboardEvent = new ClipboardEvent('copy', { clipboardData: new DataTransfer() })

    serializeTableForClipboard(view, clipboardEvent, false)

    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const blob = new Blob([clipboardEvent.clipboardData!.getData('text/html')], { type: 'text/html' })
    const data = [new ClipboardItem({ 'text/html': blob })]

    navigator.clipboard.write(data)

    if (cut) {
      if (isTableSelection(view.state.selection)) view.dispatch(view.state.tr.deleteSelection())
      else deleteCellContents(view.state, view.dispatch)
    }

    view.focus()
  }
